function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.9531 5.67188C10.79 5.67188 9.84375 6.61816 9.84375 7.78125C9.84375 8.94434 10.79 9.89062 11.9531 9.89062C13.1162 9.89062 14.0625 8.94434 14.0625 7.78125C14.0625 6.61816 13.1162 5.67188 11.9531 5.67188Z",
  fill: "#7C818C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.8125 9.1875C2.8125 11.7717 3.8952 14.1039 5.625 15.7679V14.8125C5.625 12.8741 7.20227 11.2969 9.14062 11.2969H11.9531C10.0148 11.2969 8.4375 9.7196 8.4375 7.78125C8.4375 5.8429 10.0148 4.26562 11.9531 4.26562C13.8915 4.26562 15.4688 5.8429 15.4688 7.78125C15.4688 9.7196 13.8915 11.2969 11.9531 11.2969H14.7656C16.704 11.2969 18.2812 12.8741 18.2812 14.8125V15.7679C20.011 14.1039 21.0938 11.7717 21.0938 9.1875C21.0938 4.14752 16.9931 0 11.9531 0C6.91315 0 2.8125 4.14752 2.8125 9.1875Z",
  fill: "#7C818C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.9844 19.7812C18.0688 19.7812 17.2958 20.3708 17.0045 21.1875H13.933C13.7205 20.5919 13.2519 20.1233 12.6562 19.9107V18.2763C14.1991 18.156 15.64 17.6708 16.875 16.8776V14.8125C16.875 13.6494 15.9287 12.7031 14.7656 12.7031H9.14062C7.97754 12.7031 7.03125 13.6494 7.03125 14.8125V16.8776C8.26685 17.6711 9.70844 18.1564 11.252 18.2765L11.257 19.9087C10.658 20.1198 10.1865 20.5895 9.97321 21.1875H6.90179C6.61047 20.3708 5.8374 19.7812 4.92188 19.7812C4.00635 19.7812 3.23328 20.3708 2.94196 21.1875H0V22.5938H2.94196C3.23328 23.4104 4.00635 24 4.92188 24C5.8374 24 6.61047 23.4104 6.90179 22.5938H9.97321C10.2645 23.4104 11.0376 24 11.9531 24C12.8687 24 13.6417 23.4104 13.933 22.5938H17.0045C17.2958 23.4104 18.0688 24 18.9844 24C19.8999 24 20.673 23.4104 20.9643 22.5938H23.9531V21.1875H20.9643C20.673 20.3708 19.8999 19.7812 18.9844 19.7812Z",
  fill: "#7C818C"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgAffiliate = function SvgAffiliate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAffiliate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/affiliate.3dc53f4d.svg";
export { ForwardRef as ReactComponent };